import React from "react";

import { Button, Divider, Space, Switch, Select } from "antd";
import { jobStatus } from "../../../../components/job/status";

const Filters = (props) => {
    const { filters } = props;
    const isActive = filters ? filters.active == 1 : false;

    const unassigned = filters ? filters.unassigned == 1 : false;

    const estado = filters ? (filters.estado ? filters.estado : undefined) : undefined;
    const project = filters ? (filters.project ? parseInt(filters.project) : undefined) : undefined;
    const pointOfSale = filters ? (filters.pointOfSale ? parseInt(filters.pointOfSale) : undefined) : undefined;
    const manager = filters ? (filters.manager ? parseInt(filters.manager) : undefined) : undefined;
    //const component = filters ? (filters.component ? parseInt(filters.component) : undefined) : undefined;

    const _filter = (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;

    return (
        <>
            <Space size="small">
                <Switch
                    checked={isActive}
                    size="small"
                    onChange={(bool) => props.onUpdateFilters({ active: bool ? 1 : 0 })}
                />{" "}
                Actives
                <Divider type="vertical " />
                <Switch
                    checked={unassigned}
                    size="small"
                    onChange={(bool) => props.onUpdateFilters({ unassigned: bool ? 1 : undefined })}
                />{" "}
                Unassigned
            </Space>
            <br />
            <br />
            <Space size="small">
                Filters:
                <Select
                    placeholder="Status"
                    allowClear
                    name="estado"
                    size="small"
                    showSearch
                    options={jobStatus}
                    filterOption={_filter}
                    style={{ minWidth: "150px" }}
                    value={estado}
                    onChange={(e) => {
                        props.onUpdateFilters({ estado: e ? e : undefined });
                    }}
                />
                <Select
                    placeholder="Project"
                    allowClear
                    name="Project"
                    size="small"
                    showSearch
                    options={props.projects}
                    filterOption={_filter}
                    style={{ minWidth: "150px" }}
                    value={project}
                    onChange={(e) => {
                        props.onUpdateFilters({ project: e ? e : undefined });
                    }}
                />
                <Select
                    placeholder="Point Of Sale"
                    allowClear
                    name="pointOfSale"
                    size="small"
                    showSearch
                    options={props.pointsOfSale}
                    filterOption={_filter}
                    style={{ minWidth: "150px" }}
                    value={pointOfSale}
                    onChange={(e) => {
                        props.onUpdateFilters({ pointOfSale: e ? e : undefined });
                    }}
                />
                <Select
                    placeholder="Manager"
                    allowClear
                    name="manager"
                    size="small"
                    showSearch
                    options={props.managers}
                    filterOption={_filter}
                    style={{ minWidth: "150px" }}
                    value={manager}
                    onChange={(e) => {
                        props.onUpdateFilters({ manager: e ? e : undefined });
                    }}
                />
                {/*
                <Select
                    placeholder="Component"
                    allowClear
                    name="component"
                    size="small"
                    showSearch
                    options={props.components}
                    filterOption={_filter}
                    style={{ minWidth: "150px" }}
                    value={component}
                    onChange={(e) => {
                        props.onUpdateFilters({ component: e ? e : undefined });
                    }}
                />
                <Button type="link" htmlType="button">
                    Reset Filters
                </Button>
                */}
            </Space>
        </>
    );
};

export default Filters;
